const NORMALIZE_CSS = `


html {
  line-height: 1.15; /* 1 */
  -ms-text-size-adjust: 100%; /* 2 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

h3 {
    display: block;
    font-size: 15px; /* 1.17em; */
    font-family: 'Lato', sans-serif;
    -webkit-font-smoothing: antialiased;
    -webkit-margin-after: 0px;
    -webkit-margin-before: 10px;
    -webkit-margin-end: 0px;
    -webkit-margin-start: 0px;
    -webkit-tap-highlight-color:
}

body {
  margin: 0;
}



article,
aside,
footer,
header,
nav,
section {
  display: block;
}



h1 {
  font-size: 2em;
  margin: 0.67em 0;
}


figcaption,
figure,
main { /* 1 */
  display: block;
}


figure {
  margin: 1em 40px;
}


hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}



pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}



a {
  background-color: transparent; /* 1 */
  -webkit-text-decoration-skip: objects; /* 2 */
}

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}


b,
strong {
  font-weight: inherit;
}


b,
strong {
  font-weight: bolder;
}

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}


dfn {
  font-style: italic;
}

mark {
  background-color: #ff0;
  color: #000;
}


small {
  font-size: 80%;
}


sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



audio,
video {
  display: inline-block;
}


audio:not([controls]) {
  display: none;
  height: 0;
}



img {
  border-style: none;
}


svg:not(:root) {
  overflow: hidden;
}


button,
input,
optgroup,
select,
textarea {
  font-family: sans-serif; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}


button,
input { /* 1 */
  overflow: visible;
}


button,
select { /* 1 */
  text-transform: none;
}


button,
html [type="button"], /* 1 */
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; /* 2 */
}


button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}


button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}


fieldset {
  padding: 0.35em 0.75em 0.625em;
}


legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}


progress {
  display: inline-block; /* 1 */
  vertical-align: baseline; /* 2 */
}



textarea {
  overflow: auto;
}



[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}



[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}



[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}



[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}



details, /* 1 */
menu {
  display: block;
}


summary {
  display: list-item;
}


canvas {
  display: inline-block;
}



template {
  display: none;
}


[hidden] {
  display: none;
}



`;

const CEDARVILLE_URL = 'https://fonts.googleapis.com/css?family=Cedarville+Cursive';
const LATO_URL = 'https://fonts.googleapis.com/css?family=Open+Sans:300,400,500,600,700';

const INLINE_STYLES = componentType => `


@font-face{
  font-family: 'Lato';
  src: url('${LATO_URL}');
}

@font-face{
  font-family: 'Cedarville Cursive';
  src: url('${CEDARVILLE_URL}');
}

body {
  font-family: BlinkMacSystemFont, "Lato", Roboto, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.5;
  color: #666666;
  background-color: #fbfcfc;
}


.contract-html h2 {
  color: #000;
  margin-top: 20px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
}

.contract-html h3 {
  margin-top: 20px !important;
  font-size: ${componentType === 'pdf' ? '12px' : '19px'};
  font-weight: 600 !important;
  text-transform: uppercase !important;
  font-family: Lato, sans-serif !important;
}

.wrapper {
  box-sizing:border-box;
  color: rgb(0, 0, 0);
  display: block;
  font-family: Lato, sans-serif;
  font-size: 18px; /* 24px; */
  font-weight: 500;
  height:36px;
  line-height: 36px;
  margin: 0px;
  padding: 0px;
}

.contract-html div p {
  margin-bottom: 10px;
  font-size: ${componentType === 'pdf' ? '10px' : '16px'};
}

.the-parties-hereto {
  font-size: ${componentType === 'pdf' ? '10px' : '16px'};
  margin-top: 55px;
  font-weight: 700;
  margin-bottom: 35px;
}

.signature-container .zero-font {
  font-size: ${componentType === 'pdf' ? '10px' : '14px'};
  margin-top: 5px;
  color: #000;
}
.signature-container .nine-font {
  font-size: ${componentType === 'pdf' ? '10px' : '13px'};
  margin-top: 5px;
  color: #999;
}

.section-title {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 700;
  margin: 20px 0px 20px 0px;
}
.sub-section-text {
  font-size: 16px;
}
.sub-section-title {
  font-weight: bold;
}
.contract-component {
  padding: 80px;
  color: #4D4D4D;
  background-color: white;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  background: #FFF;
}
@media (max-width: 769px) {
  .contract-component {
    padding: 15px;
  }
}

.signature-container {
  min-height: 135px;
  display: flex;
  text-align: left;
  flex-direction: column;
  justify-content: center;
}

.contract-component .title-wrapper {
  text-align: center;
  min-height: 115px;
  padding: 20px;
  marginBottom: 10px;
}
.contract-component .title-wrapper .title {
  color: #000;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
}
.contract-component h1 {
  font-size: ${componentType === 'pdf' ? '14px' : '30px'};
  color: #000;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: 'Lato', sans-serif;
  -webkit-text-size-adjust: 100%;
}
/*@media screen and (-webkit-min-device-pixel-ratio:0) { */
@media (max-width: 769px) {
  select,
  textarea,
  input {
    font-size: 16px !important;
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Lato', sans-serif;
  -webkit-font-smoothing: antialiased;
  -webkit-margin-after: 0px;
  -webkit-margin-before: 10px;
  -webkit-margin-end: 0px;
  -webkit-margin-start: 0px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
p,
span {
  font-family: 'Lato', sans-serif;
}
/* Change the white to any color ;) */
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 30px white inset;
}
a {
  text-decoration: none;
  font-family: 'Lato', sans-serif;
}

.signature-wrapper {
  width: 265px;
  border-bottom:1px dashed #ddd;
}

.signature-text {
  font-family: 'Cedarville Cursive';
  font-size: 23px;
}

body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td, hr, button, article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    margin: 0;
    padding: 0;
}
p, span {
    font-family: 'Lato', sans-serif;
    margin: 0;
    padding: 0;
}

* {
  box-sizing: border-box;
}

.contract-row {
  display: flex !important;
}

.contract-col {
  flex: 1 !important;
}

`;

export default INLINE_STYLES;



// WEBPACK FOOTER //
// ./src/components/common/ContractComponent/inline-styles.js